import Select, { GroupBase } from "react-select";
import { CustomDropdownIndicator, EmptyOptions, selectStyle, SingleSelectOption } from "./SelectInputUtils";
import "./style.scss";
import OliverText, { TextColors, TextType } from "../OliverText";

// Generic type for any option
export type SingleOption<T> = T;

// Props for single select
interface SingleSelectProps<T> {
    options: T[];
    value: T | null;
    onChange: (value: T | null) => void;
    placeholder?: string;
    onLoadMore?: () => void;
    hasMore?: boolean;
    onSearch?: (value: string) => void;
    getOptionValue?: (option: T) => string;
    getOptionLabel?: (option: T) => string;
    height?: "small" | "medium" | "xs";
    label?: string;
    labelType?: TextType;
    labelColor?: TextColors;
}

const SingleSelect = <T,>({
    options,
    value,
    onChange,
    placeholder = "Select...",
    onLoadMore,
    onSearch,
    hasMore = false,
    getOptionValue = option => String(option),
    getOptionLabel = option => String(option),
    height = "medium",
    label,
    labelType = TextType.BODY_2,
    labelColor = "base-blue"
}: SingleSelectProps<T>) => {
    return (
        <div className="single-select-container">
            {label && <OliverText text={label} type={labelType} color={labelColor} />}
            <Select<T, false, GroupBase<T>>
                data-height={height}
                className="react-select-container"
                options={options}
                value={value as any}
                onChange={val => onChange(val as any)}
                isMulti={false}
                isSearchable
                placeholder={placeholder}
                getOptionValue={getOptionValue}
                getOptionLabel={getOptionLabel}
                onMenuScrollToBottom={() => {
                    if (hasMore && onLoadMore) onLoadMore();
                }}
                onInputChange={val => {
                    if (onSearch) onSearch(val);
                    return val;
                }}
                menuPortalTarget={document.body}
                styles={selectStyle(height)}
                menuPosition="absolute"
                menuPlacement="auto"
                components={{
                    Option: SingleSelectOption,
                    DropdownIndicator: CustomDropdownIndicator,
                    IndicatorSeparator: () => null,
                    NoOptionsMessage: EmptyOptions
                }}
            />
        </div>
    );
};

export default SingleSelect;
